var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentLinks = function SvgPaymentLinks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.883 8.758 1.18 1.18a5.832 5.832 0 0 1 0 8.25l-.296.294a5.834 5.834 0 1 1-8.25-8.25l1.18 1.179a4.166 4.166 0 1 0 5.892 5.892l.295-.295a4.167 4.167 0 0 0 0-5.891l-1.18-1.18 1.18-1.178Zm5.598 5.01-1.178-1.179a4.169 4.169 0 0 0-1.343-6.81 4.166 4.166 0 0 0-4.55.918l-.294.295a4.166 4.166 0 0 0 0 5.891l1.179 1.18-1.18 1.178-1.178-1.178a5.834 5.834 0 0 1 0-8.25l.295-.295a5.834 5.834 0 0 1 8.25 8.25Z",
    fill: "#1D1737"
  })));
};
export default SvgPaymentLinks;